"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debug = exports.isInIframe = exports.isTest = exports.isProd = void 0;
const tslib_1 = require("tslib");
const process_1 = tslib_1.__importDefault(require("process"));
const deviceUtils_1 = require("../deviceUtils");
// Note: using import.meta.env.DEV does not work here due to backward compatibility with webpack and jest setups
exports.isProd = process_1.default.env.NODE_ENV === 'production' || location.protocol.startsWith('https');
exports.isTest = process_1.default.env.NODE_ENV === 'test';
exports.isInIframe = (0, deviceUtils_1.inIframe)();
const debug = (message) => !exports.isTest && console.debug(message);
exports.debug = debug;
